import { useNavigate, useParams } from 'react-router-dom';
import { useQuery, useMutation } from '@apollo/client';
import { Formik } from 'formik';
import Button from '../components/Button';
import { Field, FieldInput, FieldLabel } from '../components/Field';
import Loader from '../components/Loader';
import { Modal, ModalExit, ModalName, ModalPart } from '../components/Modal';
import { useToast } from '../components/Toast';
import { SPACE } from '../utilities/queries';
import { UPDATE_SPACE_SLUG } from '../utilities/mutations';
import { useSpaceContext } from '../contexts/space';

const EditSpaceSlugModal = () => {
  const navigate = useNavigate();
  const params = useParams();
  const toast = useToast();
  const { spaceVars } = useSpaceContext();
  const { loading, data } = useQuery(SPACE, {
    variables: { slug: params.s, ...spaceVars },
  });
  const [updateSpaceSlug] = useMutation(UPDATE_SPACE_SLUG);

  const close = () =>
    !loading && navigate(`/s/${data.space.slug}/settings/main`);

  return (
    <Modal onClose={() => close()}>
      {loading ? (
        <ModalPart>
          <Loader />
        </ModalPart>
      ) : (
        <>
          <ModalExit />
          <ModalName>Edit space slug</ModalName>
          <Formik
            initialValues={{ slug: data.space.slug }}
            onSubmit={async (values) => {
              try {
                const val = await updateSpaceSlug({
                  variables: {
                    slug: values.slug,
                    id: data.space.id,
                  },
                });
                navigate(`/s/${val.data.updateSpaceSlug.slug}/settings/main`);
                toast({ children: 'Space slug updated' });
              } catch (error) {
                toast({ children: error.message });

                return;
              }
            }}
          >
            {({
              values,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
            }) => (
              <form onSubmit={handleSubmit}>
                <ModalPart>
                  <Field>
                    <FieldLabel>Space slug</FieldLabel>
                    <FieldInput
                      type="slug"
                      name="slug"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.slug}
                      data-autofocus
                    />
                  </Field>
                </ModalPart>
                <ModalPart>
                  <Button
                    type="submit"
                    disabled={values.slug === data.space.slug || isSubmitting}
                    isPrimary
                    isExtended
                  >
                    Save
                  </Button>
                </ModalPart>
              </form>
            )}
          </Formik>
        </>
      )}
    </Modal>
  );
};

export default EditSpaceSlugModal;
